import { Route, BrowserRouter, Routes, Navigate } from 'react-router-dom';
// import Home from './pages/Home';
import { Context } from "./globals/Context";
import Footer from './globals/Footer';
import { useEffect, useState, Component, ErrorInfo, ReactNode } from 'react';
// import Info from './pages/Info';
// import Location from './pages/Location'
import './css/App.css';
import sunriseImage from './assets/sunrise.png';
import { clearCacheAndReload } from './utils/cacheUtils';
// import TestError from './pages/TestError';
import ThankYou from './pages/ThankYou';

// Error boundary component to catch and display runtime errors
class ErrorBoundary extends Component<{ children: ReactNode, fallback?: ReactNode }> {
  state = { hasError: false, error: null };
  
  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }
  
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Log the error but prevent it from bubbling up to the browser
    console.error("Uncaught error:", error, errorInfo);
  }
  
  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div className="error-container" style={{
          padding: '20px',
          margin: '20px auto',
          maxWidth: '500px',
          textAlign: 'center',
          backgroundColor: 'rgba(0,0,0,0.7)',
          borderRadius: '8px',
          color: 'white'
        }}>
          <h2>Something went wrong</h2>
          <p>We've detected an issue with the application. This might be due to cached data.</p>
          <button 
            onClick={() => clearCacheAndReload(true)}
            style={{
              padding: '10px 20px',
              backgroundColor: '#ff4b4b',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '16px',
              marginTop: '10px'
            }}
          >
            Clear Cache & Refresh
          </button>
        </div>
      );
    }
    
    return this.props.children;
  }
}

// Global error handler to suppress browser error dialogs
if (typeof window !== 'undefined') {
  // Prevent unhandled promise rejections from showing browser error dialog
  window.addEventListener('unhandledrejection', (event) => {
    event.preventDefault();
    console.error('Unhandled Promise Rejection:', event.reason);
  });

  // Prevent uncaught exceptions from showing browser error dialog
  window.addEventListener('error', (event) => {
    event.preventDefault();
    console.error('Uncaught Error:', event.error);
  });
}

function App() {
  const [isLoggedIn, setLoggedIn] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    console.log('App level, is logged in', isLoggedIn)
  }, [isLoggedIn])

  // Use window width to determine background size
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="background-wrapper">
    <div className="App" style={{ 
      backgroundImage: `url(${sunriseImage})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: windowWidth >= 768 ? '100% auto' : 'cover',
      backgroundPosition: 'center'
    }}>
            <Context.Provider value={{isLoggedIn, setLoggedIn}}>
            <BrowserRouter >
        <Routes>
          {/* Original routes - commented out but preserved for future use */}
          {/* <Route path="/" element={<ErrorBoundary><Home/></ErrorBoundary>} /> */}
          {/* <Route path="/info" element={<ErrorBoundary><Info /></ErrorBoundary>} /> */}
          {/* <Route path="/test-error" element={<ErrorBoundary><TestError /></ErrorBoundary>} /> */}
          {/* <Route path="/location" element={<Location/>} /> */}
          
          {/* New thank you route */}
          <Route path="/" element={<ErrorBoundary><ThankYou /></ErrorBoundary>} />
          
          {/* Redirect all other routes */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </Context.Provider>
      <Footer />
    </div>
    </div>
  );
}

export default App;
